export default "__VITE_ASSET__BCpzicJj__"